import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-prismPDM-logo',
	template: `    
	<img 	routerLink="/"
			src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/Logo%20-%20PRISMPdM.png"
			title="Prism Image"
			[ngStyle]="customStyles"
			[attr.x-contenttype]="'image/png'">
  	`,
	styles: [``]
})
export class PrismPDMLogoComponent {
	@Input() customStyles: { [key: string]: string | number } = {};
}
